import { GetInterfaceInput } from "@zapier/bff";
import { trpc } from "../trpc";
import { keepPreviousData } from "@tanstack/react-query";

type Input = GetInterfaceInput;

interface Options {
  enabled?: boolean;
}

export function useFetchInterfaceZaps(input: Input, options?: Options) {
  const { data, isLoading, isFetching } = trpc.interface.getZaps.useQuery(
    {
      ...input,
    },
    {
      placeholderData: keepPreviousData,
      trpc: {
        context: {
          // Skip batching to avoid bundling this critical procedure with slower requests
          skipBatching: true,
        },
      },
      enabled: options?.enabled && !!input.id,
    },
  );

  return {
    interfaceZaps: data || [],
    isLoading: isLoading,
    isFetching: isFetching,
  };
}
